"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _form = require("../form");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Button = (0, _styledComponents.default)(_form.FormButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0;\n"])));
exports.Button = Button;